import { IoCloseOutline } from "react-icons/io5"

import BackgroundWrapper from "@fuse/sharedComponents/backgroundWrapper"
import BlurWrapper from "@fuse/sharedComponents/blurWrapper"
import SolidBtn from "@fuse/sharedComponents/buttons/SolidBtn"
import LoadingSpinnerInline from "@fuse/sharedComponents/loader/LoadingSpinnerInline"
import Modal from "@fuse/sharedComponents/modal/Modal"

import {
  DownloadLinkMap,
  onOpenDownloadLink,
  useDeviceDetection,
} from "@fuse/utils/DeviceDection"

import { VERIFY } from "@fuse/pages/emailVerification/constant"
import { useVerify } from "@fuse/pages/emailVerification/useVerify"

import Grimacing from "@fuse/assets/gif/gif-grimacing.gif"

const bgImage = "/assets/alpha-event-not-found.svg"

export const InstrestedEmailCapture = ({
  onClose,
}: {
  onClose: () => void
}) => {
  const device = useDeviceDetection()
  const downloadLink = DownloadLinkMap[device]

  const SuccessScreen = () => {
    return (
      <div className="flex flex-col justify-center items-center max-w-[422px] p-8">
        <h2 className="text-2xl font-semibold text-white mb-3">
          Enter your email to stay updated!
        </h2>
        <p className="text-white/70 text-center text-sm mb-6">
          Get all the latest event updates directly to your inbox. Don't miss
          out on important details—share your email below!
        </p>
        <div className="w-full">
          <input
            type="email"
            placeholder="oliviaadams@gmail.com"
            className="w-full px-4 py-3 rounded-lg bg-white/10 text-white border border-white/20 focus:outline-none focus:border-white/40 mb-4"
          />
          <button className="w-full py-3 bg-white/20 hover:bg-white/30 text-white rounded-lg font-medium transition-colors">
            Keep me updated
          </button>
          <p className="text-white/50 text-xs text-center mt-4">
            Your email is safe with us. No spam—just event updates you care
            about!
          </p>
        </div>
      </div>
    )
  }

  const FailureScreen = () => {
    return (
      <div className="flex flex-col justify-center items-center max-w-[518px]">
        <img className="w-28" src={Grimacing} />
        <div className="mt-6 text-[32px] font-semibold text-white">
          {VERIFY.EMAIL.TEXTS.FAILURE.HEADING}
        </div>
        <div className="mt-4 text-white/35">
          {VERIFY.EMAIL.TEXTS.FAILURE.SUBHEADING}
        </div>
        <div className="mt-4 text-white/35">
          {VERIFY.EMAIL.TEXTS.FAILURE.BODY}
        </div>
        <SolidBtn
          size="lg"
          variant={"solid"}
          onClick={() => onOpenDownloadLink(downloadLink)}
          className="inline-flex text-white opacity-100 px-10 min-w-60 w-full sm:w-auto mt-6"
        >
          Download the app
        </SolidBtn>
      </div>
    )
  }

  const LoadingScreen = () => {
    return (
      <div className="flex flex-col justify-center items-center ">
        <div className="relative z-[10]">{<LoadingSpinnerInline />}</div>
        <div className="mt-6 text-[32px] mb-10 text-white">
          {VERIFY.EMAIL.TEXTS.LOADING.HEADING}
        </div>
      </div>
    )
  }

  return (
    <div className="fixed inset-0 max-h-[100vh] flex items-center justify-center bg-black bg-opacity-50 z-[9999]">
      <BlurWrapper
        overlayColorDefault="dark"
        overlayOpacityDefault="80"
        className="flex items-center  rounded-2xl justify-center"
      >
        <div className=" bg-[#ffffff1A] rounded-2xl shadow-lg text-center max-w-xs md:max-w-xl w-full flex flex-col relative">
          <div className="absolute top-3 right-3">
            <div
              onClick={() => {
                onClose()
              }}
              className="pointer-events-auto cursor-pointer focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75"
            >
              <IoCloseOutline color="white" size={26} />
            </div>
          </div>
          <div className="flex flex-col items-center justify-center p-8">
            <SuccessScreen />
          </div>
        </div>
      </BlurWrapper>
    </div>
  )
}
